import commonMapping from "@/mapping/common";

export const remote = {
  enable: commonMapping.intToBoolean,
};

export default remote;
